module.exports = __webpack_public_path__ + "img/icon-logout.dd21d8c4.svg";